module.exports = __webpack_public_path__ + "img/adshow.8ac6642f.png";